import React, {useCallback, useEffect, useMemo, useState} from "react";
import {EducationModifyProps} from "../types";
import {
    postUserEducationSubmit,
    postUserEducationModify,
    getUserEducationById,
    removeUserEducationById
} from "../../service";
import useForm from "rc-form-hooks";
import Input from "../../components/inputItem";
import DatePickerBox from "./datePicker";
import {useHistory, useParams} from "react-router-dom";
import {getUserStorage} from "../../units";
import {useLoading} from "../../components/loading/LoadingProvider";
import useUserInfo from "../../routers/useUserInfo";
import {useModal} from "../../components/modal";

const dateConfig = {
    'year': {
        format: 'YYYY',
        caption: '年',
        step: 1,
    },
    'month': {
        format: 'M',
        caption: '月',
        step: 1,
    },
}

interface EducationModalForm {
    id?:string,
    school: string,
    subject: string,
    degree: string,
    customerId?:string,
    start: string,
    end: string
}

const EducationModal = () => {

    const params = useParams<{ id?: string }>()
    const userData = useUserInfo()
    const loading = useLoading()
    const his = useHistory()
    const modal = useModal()

    const {getFieldDecorator, validateFields, errors, values,setFieldsValue} = useForm<EducationModalForm>();

    const [form,setForm] = useState<EducationModalForm>({
        id:'',
        school:'',
        start:'',
        degree:'',
        subject:'',
        customerId:'',
        end:''
    })

    const deleteHandle = (id:string) => {
        if(userData){
            modal.show({
                content:'是否删除该简历?',
                success(res){
                    if(res.confirm){
                        loading.showLoading()
                        removeUserEducationById({
                            userId:userData.id,
                            educationId :id
                        }).then(res => {
                            if(res.code === 1){
                                loading.showSuccess('删除成功',() => {
                                    his.goBack()
                                })
                            }else{
                                loading.showError(res.msg)
                            }
                        })
                    }
                }
            })

        }
    }

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (userData) {
            validateFields().then((_values) => {
                if (!params.id) {
                    loading.showLoading('请求中...')
                    postUserEducationSubmit({
                        userId: userData.id,
                        ..._values
                    }).then(res => {
                        if (res.code === 1) {
                            loading.showSuccess('添加成功', () => {
                                his.goBack()
                            })
                        }else{
                            loading.showError(res.msg)
                        }
                    })
                }else{
                    loading.showLoading('请求中...')
                    postUserEducationModify({
                        userId:userData.id,
                        educationId:params.id,
                        ..._values
                    }).then(res => {
                        if (res.code === 1) {
                            loading.showSuccess('修改成功', () => {
                                his.goBack()
                            })
                        }else{
                            loading.showError(res.msg)
                        }
                    })
                }
            })
        }
    }

    useEffect(() =>{
        if(params.id && userData){
            loading.showLoading()
            getUserEducationById({
                educationId:params.id,
                userId:userData.id
            }).then(res => {
                if(res.code === 1){
                    loading.hideLoading()
                    setFieldsValue(res.data)
                }else{
                    loading.showError(res.msg)
                }

            })
        }
    },[params])

    // console.log(form)


    return <div className='education-modal' style={{paddingTop: '.2rem'}}>

        <form onSubmit={handleSubmit}>
            {
                getFieldDecorator('school', {
                    rules: [{required: true, message: '请输入学校名称'}],
                    initialValue: form.school
                })(<Input label='学校名称' type={'text'} placeholder='请输入学校名称'
                          extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }
            {
                getFieldDecorator('subject', {
                    rules: [{required: true, message: '请输入专业名称'}],
                    initialValue: form.subject
                })(<Input label='专业名称' type={'text'} placeholder='请输入专业名称'
                          extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }
            {
                getFieldDecorator('degree', {
                    rules: [{required: true, message: '请输入最高学历'}],
                    initialValue: form.degree
                })(<Input label='最高学历' type={'text'} placeholder='请输入最高学历'
                          extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }
            {
                getFieldDecorator('start', {
                    rules: [{required: true, message: '请选择开始日期'}],
                    initialValue: form.start
                })(<DatePickerBox DateConfig={dateConfig} label={'开始日期'}/>)
            }
            {
                getFieldDecorator('end', {
                    rules: [{required: true, message: '请输入结束日期'}],
                    initialValue: form.end
                })(<DatePickerBox DateConfig={dateConfig} label={'结束日期'}/>)
            }
            <button style={{marginLeft: '.3rem', marginRight: '.3rem', width: 'calc(100% - .6rem)'}} type={'submit'}
                    className="common-btn submit">确认
            </button>
        </form>
        {
            params.id && <div className="common-btn delete" onClick={() =>  deleteHandle((params.id as string)) } style={
                {
                    marginLeft: '.3rem',
                    marginRight: '.3rem',
                    width: 'calc(100% - .6rem)',
                    borderRadius:'.1rem',
                    color:"#ff0000",
                    backgroundColor:'transparent',
                    border:'1px solid #ff0000',
                    lineHeight:'.85rem',
                    marginTop:'.3rem'
                }
            }>
                删除简历
            </div>
        }

    </div>
}

export default EducationModal
